import React from "react";

import { Table } from "../../UI/Table";
import { TableRow } from "../../UI/TableRow";
import { TableHead } from "../../UI/TableHead";
import { TableCell } from "../../UI/TableCell";
import { UserNameLink } from "../UserNameLink";
import { PageTablePagination } from "../PageTablePagination";
import { dateToMMDDYY, getDate } from "../../common/date_utils";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { ModalProvider } from "../../contexts/ModalContext";

interface IProps {
  roommatesQty: number;
  results: any[];
  isLoading: boolean;
  reloadResults: VoidFunction;
}

export const UserReportTable: React.FC<IProps> = (props) => (
  <>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Join Date</TableCell>
        </TableRow>
      </TableHead>
      <EnhancedTableBody colSpan={10} isLoading={props.isLoading}>
        {props.results.map((result) => (
          <TableRow key={result.uid}>
            <TableCell>
              <ModalProvider>
                <UserNameLink
                  openNewTab
                  id={result.membershipId}
                  name={`${result.firstName} ${result.lastName}`}
                />
              </ModalProvider>
            </TableCell>
            <TableCell>
              {dateToMMDDYY(getDate(result.joinDate.slice(0, 3)))}
            </TableCell>
          </TableRow>
        ))}
      </EnhancedTableBody>
    </Table>
    <PageTablePagination />
  </>
);
